var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgManagerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.39434 10.1378C8.85367 10.1378 10.9557 10.5105 10.9557 11.9992C10.9557 13.4878 8.86767 13.8712 6.39434 13.8712C3.93434 13.8712 1.83301 13.5018 1.83301 12.0125C1.83301 10.5232 3.92034 10.1378 6.39434 10.1378Z",
    stroke: "#222222",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.3947 8.01317C4.78004 8.01317 3.4707 6.7045 3.4707 5.08984C3.4707 3.47517 4.78004 2.1665 6.3947 2.1665C8.0087 2.1665 9.31804 3.47517 9.31804 5.08984C9.32404 6.6985 8.02404 8.00717 6.41537 8.01317H6.3947Z",
    stroke: "#222222",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10.9883 7.25439C12.0556 7.10439 12.8776 6.18839 12.8796 5.07972C12.8796 3.98706 12.0829 3.08039 11.0383 2.90906",
    stroke: "#222222",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M12.3965 9.82141C13.4305 9.97541 14.1525 10.3381 14.1525 11.0847C14.1525 11.5987 13.8125 11.9321 13.2632 12.1407",
    stroke: "#222222",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgManagerIcon);
export default __webpack_public_path__ + "static/media/managerIcon.249826c3c3f46665dfb33eabd8cb51e1.svg";
export { ForwardRef as ReactComponent };